module.exports = {"stepComponents":{"priceInput":{"component":{"props":[{"actions":[{"actionType":"modal","props":{"name":"tjmSaveOfferErrorMessage"}}]},{"columnElements":[{"columnProps":[{},{"id":"paymentFrequency-cat","showHide":{"userData":{"key":"paymentType","value":"pbs"}}}]}]}]}},"priceAdvancedInput":{"component":{"props":[{"actions":[{"actionType":"modal","props":{"name":"tjmSaveOfferErrorMessage"}}]},{"columnElements":[{"columnProps":[{},{"id":"paymentFrequency-cat","showHide":{"userData":{"key":"paymentType","value":"pbs"}}}]}]}]}}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/cat/package.cat-tjm.json
// module id = 659
// module chunks = 0